var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2344 4.99951C30.5339 4.99951 30.8203 5.059 31.0937 5.17797C31.5234 5.34981 31.8652 5.62079 32.1191 5.99092C32.373 6.36105 32.5 6.77083 32.5 7.22027V32.7788C32.5 33.2282 32.373 33.638 32.1191 34.0081C31.8652 34.3782 31.5234 34.6492 31.0937 34.8211C30.8464 34.9268 30.5599 34.9797 30.2344 34.9797C29.6094 34.9797 29.069 34.7682 28.6133 34.3452L20 25.938L11.3867 34.3452C10.918 34.7814 10.3776 34.9995 9.76562 34.9995C9.46615 34.9995 9.17969 34.94 8.90625 34.8211C8.47656 34.6492 8.13477 34.3782 7.88086 34.0081C7.62695 33.638 7.5 33.2282 7.5 32.7788V7.22027C7.5 6.77083 7.62695 6.36105 7.88086 5.99092C8.13477 5.62079 8.47656 5.34981 8.90625 5.17797C9.17969 5.059 9.46615 4.99951 9.76562 4.99951H30.2344Z",
    fill: "#4674B9",
    stroke: "white",
    strokeWidth: 5.15827
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkActive);
export default __webpack_public_path__ + "static/media/bookmark_active.c71559120153d4b9f46f9c26721754ef.svg";
export { ForwardRef as ReactComponent };